import globals from './globals';

export default {

	isMobile() {
		return innerWidth < 1024;
	},

	isDesktop() {
		return innerWidth >= 1024;
	},

	isIE() {
		return globals.$app.hasClass('is-browser-ie');
	},

	getScrollbarWidth() {
		const width = innerWidth - globals.$html.clientWidth;

		if (width) {
			return width;
		}

		const div = document.createElement('div');

		div.style.cssText = 'width:100px;height:100px;overflow:scroll !important;position:absolute;top:-9999px';
		document.body.appendChild(div);

		const scrollBarWidth = div.offsetWidth - div.clientWidth;

		document.body.removeChild(div);

		return scrollBarWidth;
	},

	scrollTo(position, duration = 500) {
		return new Promise((resolve) => {
			$('html, body')
				.stop()
				.animate({
					scrollTop: position,
				}, duration, 'swing', resolve);
		});
	},

	resize(name, callback) {
		if (innerWidth === globals.$window.data(`width-${name}`)) {
			return;
		}

		clearTimeout(globals.$window.data(`resize-${name}`));

		globals.$window.data({
			[`width-${name}`]: innerWidth,
			[`resize-${name}`]: setTimeout(callback, 500),
		});
	},

	clearText(text) {
		return text.toString().trim().replace(/\s+/, ' ');
	},

};
